import { ChevronRight } from "lucide-react";
import "./ArrowButton.css";

const ArrowButton = ({ isOpen, onClick, color, isSelected }) => (
    <button
        className={`arrow-btn ${isOpen ? "open" : ""}`}
        onClick={onClick}
        style={{
            backgroundColor: isSelected ? "var(--colorFront)" : color,
            color: isSelected ? "var(--colorBack)" : "var(--colorFront)",
            borderColor: "var(--colorFront)",
        }}
    >
        <ChevronRight size={16} strokeWidth={2.5} />
    </button>
);

export default ArrowButton;

// className={`arrow-btn ${openParent === val ? "open" : ""}`}

/*





        */